import pic1 from '../assets/01.png'
import pic2 from '../assets/02.png'
import pic3 from '../assets/03.png'
import pic4 from '../assets/04.jpg'

export const ProjectList = [
    {
        name: "Staybnb",
        image: pic1,
        skills: "HTML,CSS,Javascript",
    },
    {
        name: "Playstation5",
        image: pic2,
        skills: "Bootstrap",
    },
    {
        name: "Personal Porfolio",
        image: pic3,
        skills: "React",
    },
    {
        name:"More coming soon",
        image: pic4,
    }
]